// Packages and components
import React from 'react';
import { Box, Image } from 'grommet';
import { StyledSvgImage } from './SHDImage.styles';

// Helpers and utlities
import { borderRadiusSize } from '@theme/globals/sizing';
import { isSvg } from '@theme/utils/data';
import { convertPropToSize } from '@theme/utils/sizing';

// Types
import { Fallback } from '@theme/theme.d';
import { SHDImageProps } from './SHDImage.d';

const SHDImage: React.FC<SHDImageProps> = ({
  alt,
  className = 'image',
  color = 'black',
  height = 'auto',
  isSquare = false,
  round = 'none',
  src,
  width,
}) => {
  const imageIsSvg = isSvg(src);
  const imageWidth = convertPropToSize<string>(width);
  const imageHeight = () => {
    if (isSquare) {
      return imageWidth;
    }
    if (height === 'auto') {
      return height;
    }
    return convertPropToSize<string>(height);
  };

  return (
    <Box className={className} height={imageHeight()} width={imageWidth}>
      {imageIsSvg ? (
        <StyledSvgImage
          a11yTitle={alt}
          alt={alt}
          className={`${className}__image--svg`}
          color={color}
          fallback={Fallback.IMAGE}
          fit="cover"
          src={src}
          style={{ borderRadius: borderRadiusSize[round] || round }}
        />
      ) : (
        <Image
          a11yTitle={alt}
          alt={alt}
          className={`${className}__image`}
          fallback={Fallback.IMAGE}
          fit="cover"
          src={src}
          style={{ borderRadius: borderRadiusSize[round] || round }}
        />
      )}
    </Box>
  );
};

export default SHDImage;
